import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-81faef26"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "searchbar-ct" }
const _hoisted_2 = {
  key: 0,
  class: "search-results-ct"
}
const _hoisted_3 = {
  key: 0,
  class: "py-2"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "subtitle" }
const _hoisted_7 = {
  key: 1,
  class: "p-2 py-4 text-sm text-center"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "enterBtnRep" }, null, -1))

import { showResults } from '@/states/homeState';
// import { debounce } from 'lodash';
import debounce from 'lodash/debounce';

import { Map as MapboxGLMap } from 'mapbox-gl';
import { computed, onMounted, ref } from 'vue';
import Coordinate from 'coordinate-parser';
import { memoize } from 'lodash';


export default /*#__PURE__*/_defineComponent({
  __name: 'Searchbar',
  props: {
    map: null,
    goToCoordinate: null
  },
  setup(__props: any) {

const props = __props as {
  map: MapboxGLMap;
  goToCoordinate: (latlong: { lng: number; lat: number }) => void;
}


const searchInputRef = ref<HTMLInputElement>();
const autocompleteService = ref<google.maps.places.AutocompleteService>();
const plaveService = ref<google.maps.places.PlacesService>();
const result = ref<any[]>();
const isCoordnate = ref(false);

const isValidCoord = memoize((coordinateString: string) => {
  try {
    console.log(coordinateString);

    return new Coordinate(coordinateString);
  } catch {
    return false;
  }
});

const searchCtZindex = computed(() => (showResults.value ? 20 : null));

onMounted(() => {
  autocompleteService.value = new google.maps.places.AutocompleteService();
  plaveService.value = new google.maps.places.PlacesService(document.createElement('div'));
});

const clearInput = () => {
  searchInputRef.value.value = '';
  result.value = [];
  showResults.value = false;
  isCoordnate.value = false;
};

const getPlaceDetail = async (place_id: string) => {
  plaveService.value.getDetails({ placeId: place_id }, (res, status) => {
    if (status === google.maps.places.PlacesServiceStatus.OK) {
      toCoordinate(res.geometry.location.lat(), res.geometry.location.lng());
      showResults.value = false;
    }
  });
};

const toCoordinate = (lat: number, lng: number) => {
  props.goToCoordinate({ lat, lng });
  props.map.easeTo({ zoom: 12, center: { lat, lng } });
};

const onSearchSubmit = (e: KeyboardEvent) => {
  if (e.key === 'Enter') {
    try {
      const coord = isValidCoord(searchInputRef.value.value);
      if (coord !== false) {
        toCoordinate(coord.getLatitude(), coord.getLongitude());
      }
      showResults.value = false;
    } catch {}
  }
};

const onSearchInputFocus = (e) => {
  console.log(e);

  if (e.type === 'focusout') {
    showResults.value = false;
  } else {
    if (result.value?.length > 0 || isCoordnate.value) {
      showResults.value = true;
    }
  }
};

const searchPlaces = async (query) => {
  if (query) {
    const response = await autocompleteService.value.getPlacePredictions({
      input: query,
    });

    result.value = response.predictions.map((place) => {
      return {
        place_id: place.place_id,
        title: place.structured_formatting.main_text,
        subtitle: place.structured_formatting.secondary_text,
      };
    });
    showResults.value = true;
  } else {
    result.value = undefined;
    showResults.value = false;
  }
};

const onSearchQueryChange = debounce(() => {
  if (isValidCoord(searchInputRef.value.value)) {
    isCoordnate.value = true;
    showResults.value = true;
  } else {
    isCoordnate.value = false;
  }

  searchPlaces(searchInputRef.value.value);
}, 300);

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle({ zIndex: _unref(searchCtZindex) })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Icon, {
        class: "text-xl ml-4",
        icon: "mdi:search"
      }),
      _createElementVNode("input", {
        ref_key: "searchInputRef",
        ref: searchInputRef,
        onFocus: onSearchInputFocus,
        onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(onSearchQueryChange) && _unref(onSearchQueryChange)(...args))),
        onKeypress: onSearchSubmit,
        class: "search-input",
        placeholder: "Search Location..."
      }, null, 544),
      (searchInputRef.value && searchInputRef.value.value.length > 0)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "clearInput-btn",
            onClick: clearInput
          }, [
            _createVNode(_component_Icon, {
              class: "",
              icon: "mdi:close"
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    (_unref(showResults))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (!isCoordnate.value)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(result.value, (place) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "search-results-item-ct",
                    onClick: ($event: any) => (getPlaceDetail(place.place_id))
                  }, [
                    _createElementVNode("p", _hoisted_5, _toDisplayString(place.title), 1),
                    _createElementVNode("p", _hoisted_6, _toDisplayString(place.subtitle), 1)
                  ], 8, _hoisted_4))
                }), 256))
              ]))
            : (_openBlock(), _createElementBlock("p", _hoisted_7, [
                _createTextVNode(" Press "),
                _hoisted_8,
                _createTextVNode(" to go to coordinate ")
              ]))
        ]))
      : _createCommentVNode("", true)
  ], 4))
}
}

})